"use client";
import { useEffect } from "react";

const InstagramEmbed = ({ reels = [] }) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://www.instagram.com/embed.js";
    script.async = true;
    script.onload = () => {
      if (window.instgrm) {
        window.instgrm.Embeds.process();
      }
    };
    document.body.appendChild(script);
  }, []);

  return (
    <section className="w-full">
      <div className="max-w-7xl mx-auto flex flex-wrap justify-center gap-2 md:gap-4">
        {reels.map((url, index) => (
          <div
            key={index}
            className="w-full sm:w-[48%] lg:w-[30%] xl:w-[28%]"
          >
            <blockquote
              className="instagram-media"
              data-instgrm-permalink={url}
              data-instgrm-version="13"
            ></blockquote>
          </div>
        ))}
      </div>
    </section>
  );
}

export default InstagramEmbed;
